import { render, staticRenderFns } from "./AddStarBirthday.vue?vue&type=template&id=45d2b97f&scoped=true&"
import script from "./AddStarBirthday.vue?vue&type=script&lang=js&"
export * from "./AddStarBirthday.vue?vue&type=script&lang=js&"
import style0 from "./AddStarBirthday.vue?vue&type=style&index=0&id=45d2b97f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2b97f",
  null
  
)

export default component.exports